import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';
// "Filtrar por" Nome ou Email (UsersAndGroupFilters/UsersAndGroup.tsx:19-50); o fio é do `userListUrl`.
export const userFilters = defineFilters([
  { key: 'name', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
  { key: 'email', type: 'text', label: msg`Email`, placeholder: msg`Filtrar por email` },
]);
